import { useState } from 'react';
import { MarkdownRenderer } from './MarkdownRenderer';
import CitationsList from './CitationsList';
import { ChevronDown, ChevronRight, Brain } from 'lucide-react';
import type { UrlCitation } from '@/lib/streaming/types';

interface StreamingMessageProps {
  content: string;
  annotations?: UrlCitation[];
  reasoningSummary?: string;
}

function StreamingMessage({ content, annotations, reasoningSummary }: StreamingMessageProps) {
  const [isReasoningExpanded, setIsReasoningExpanded] = useState(false);

  return (
    <div className="flex gap-3">
      {/* Streaming content */}
      <div className="flex-1 space-y-2">
        {/* Reasoning summary collapsible */}
        {reasoningSummary && (
          <button
            onClick={() => setIsReasoningExpanded(!isReasoningExpanded)}
            className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            {isReasoningExpanded ? (
              <ChevronDown className="h-3 w-3" />
            ) : (
              <ChevronRight className="h-3 w-3" />
            )}
            <Brain className="h-3 w-3" />
            <span>Ragionamento</span>
          </button>
        )}
        {isReasoningExpanded && reasoningSummary && (
          <div className="text-xs text-muted-foreground bg-muted/50 rounded-md px-3 py-2 whitespace-pre-wrap">
            {reasoningSummary}
          </div>
        )}

        <div className="text-sm break-words max-w-full">
          <MarkdownRenderer content={content} />
          {/* Blinking cursor */}
          <span className="inline-block w-1 h-4 bg-primary animate-pulse ml-0.5" />
          {annotations && annotations.length > 0 && (
            <CitationsList annotations={annotations} />
          )}
        </div>
      </div>
    </div>
  );
}

export default StreamingMessage;
